import { Box, Container, Stack, Typography } from "@mui/material";

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: "auto",
        backgroundColor: "navbarFooter.main",
      }}
      className="rounded-t-xl"
    >
      <Container maxWidth="md">
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems="center"
          justifyContent="space-between"
        >
          {/* Copyright and Links */}
          <Typography variant="subtitle2" color="text.secondary">
            &copy; {new Date().getFullYear()} Vladislavs Kirilovics
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}
